import { call, put } from 'redux-saga/effects';
import ERRORS from 'constants/errors';
import { createLogger } from 'helpers/logger';
import { setError, startLoading, stopLoading } from 'reduxConfig/auth.creators';

const log = createLogger('[auth-saga]');

export function* authRecoverEmail({ actionCode }) {
  yield put(startLoading());
  try {
    yield call(window.FIREBASE.applyActionCode, actionCode);
  } catch (error) {
    log.info('Email recovery error:', error); // eslint-disable-line
    yield put(setError(ERRORS.emailNotRecovered));
  } finally {
    yield put(stopLoading());
  }
}
